import * as Namespaces from './namespaces'

const locales = {
	[Namespaces.PARAMETERS]: {
		el: {
			'Actions':'Ενέργειες',
			'Add' : 'Προσθήκη',
			'Edit' : 'Επεξεργασία',
			'Default' : 'Προεπιλογή',
			'An error occurred!' : 'Παρουσιάστηκε σφάλμα!',
			'Work Cost' : 'Κόστος εργασίας',
			'Extra Work Cost' : 'Υπερωριακό κόστος',
			'From Date' : 'Από ημ/νία',
			'To Date'  : 'Έως ημ/νία',
			'Cost' : 'Κόστη',
			'Cost deleted successfully!' : 'Το κόστος διαγράφηκε με επιτυχία!',
			'Cost updated successfully!' : 'Το κόστος ενημερώθηκε με επιτυχία!',
			'Cost created successfully!' : 'Το κόστος δημιουργήθηκε με επιτυχία!',
			'There is a record within this date range!' : 'Υπάρχει εγγραφή εντός αυτού του εύρους ημερομηνιών',
		
	
			

			
		},
		en: {
		
		}
	},
}

export default locales